module.exports = __webpack_public_path__ + "img/feature-nutrition@2x.a338c8c9.jpg";